import { IIsiDtoFormManagerClientState } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoSelectedRecordSet } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlMark";
import { IsiPlMark, MarkUnmarkOpt } from "../PresentationLogic/IsiPlMark";
import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IsiActionContext } from "../Core/IsiActionContext";
import { IsiBc, ensureClientToServerBusinessObject, flushClientToServerBusinessObject } from "../../IsiActiveBusiness/IsiBc";
import { GLOB011 } from "../../Isilog.popins";
import { IsiIWSScreen } from "../Core/IsiIwsUICore";
import { iws_RegisterLastAction } from "../../form.ts";
import { IsiButtonType, IsiIconType, IsiModeConfirm, MenuItemCode } from "../../Isilog.enums";
import { iws_isInUpdateOrConsultState, iws_isInAddOrDuplicationState, iws_isInUpdate, iws_isInConsultState } from "../../basic";
import { IsiIWSAssociatedViewContext } from "../GridView/AssociatedView/IsiIwsAssociatedViewContext";
import { IsiEntity } from "../../IsiActiveBusiness/IsiEntity";
import { isScreenWithGrid } from "../../menu.ts";
import { IsiPlBusiness, ParamPlBusiness } from "../PresentationLogic/IsiPlBusiness"
import { IIsiServerToClientBusinessObject } from "../../IsiTypeScript/Isilog.IsiFramework.IsiCommonLibrary";

export class IsiFormManager {
    /// <summary>
    ///     Classe de gestion du formulaire.
    /// </summary>
    _state: IIsiDtoFormManagerClientState;
    _currentScreen: IsiIWSScreen;

    constructor(state: IIsiDtoFormManagerClientState) {
        this._state = state;
    }

    get currentScreen(): IsiIWSScreen {
        return this._currentScreen;
    }

    set currentScreen(value: IsiIWSScreen) {
        this._currentScreen = value;
    }

    /***
     * Indique si l'on a le droit  de  modification sur le formulaire
     * */
    get canModify() {
        return this._state.canModify;
    }
    /***
    * Indique si l'on a le droit  de  suppression sur le formulaire
    * */
    get canDelete() {
        return this._state.canDelete;
    }
    /***
    * Indique si l'on a le droit  d'ajout sur le formulaire
    * */
    get canAdd() {
        return this._state.canAdd;
    }

    /***
     * Retourne les controles détecté comme devant suprimer toutes les traductions & les contenue par défaut
     */
    get translationHardDeletionControls() {
        return this._state.translationHardDeletionControls
    }

    //getPkSelected(): IsiDtoSelectedRecordSet {

    //    let record = IsiDtoSelectedRecord.fromJS({
    //        fields:[]
    //     });

    //    record.X = screenCore.formManager.getPkSelected();// TODO GRID LBRI : sur formulaire, il faut aussi l'enreg
    //    let rs = IsiDtoSelectedRecordSet.fromJS({
    //        isAllSelected: false,
    //        records: [],
    //        lov: '-1'
    //    });

    //    rs.records.push(record);

    //    return rs;
    //}
    private _actionFormulaire(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {

            let item = actionContext.uiAction;
            let needResolve = true;
            const Refresh = "Refresh";

            switch (actionContext.uiAction.key) {
                case FORM_ADDv2:
                    needResolve = false;
                    // ORIC - 2006.10.16 - [TACHE:8840] : On supprime le focus stocke sur la page, afin d'avoir le focus par defaut en mode ajout.
                    window.iws_SaveFocusedCtrl("");
                    //appel a une methode que l'on peu surcharger
                    //LLGU - POPIN on gere le submit de manière asynchrone
                    this.currentScreen.beforeAddOnFormulaire().then((result) => {
                        if (!result.continue) { uiCore.getActionRedirect().reset(); }
                        resolve(result);
                    }).catch((result) => {
                        this._rejectTreatment(item.key, reject);
                    });
                    break;
                // ABON 27/05/2009 modification dans le cas du mode archive ou ajout de critere on ne fait rien
                case FORM_ARCHIVE_MODEv2:
                    break;
                case FORM_ARCHIVE_ONv2:
                    needResolve = false;
                    // GBAU - POPIN
                    // Appel a une methode que l'on peu surcharger
                    this.currentScreen.beforeArchiveOnFormulaire().then((result) => {
                        if (result.continue) {
                            // CEGO - 2009.05.19 - [TACHE:24896] : Appel au traitement Ajax du composant metier.
                            this._BusinessCheck("IsiArchiveCheck", "", null, true).then((checkBusinessResult: IsiBc) => {
                                if (!checkBusinessResult.bCheckOk) { uiCore.getActionRedirect().reset(); }
                                resolve({ result: true, continue: checkBusinessResult.bCheckOk });
                            }).catch((result) => {
                                this._rejectTreatment(item.key, reject);
                            });
                        } else {
                            if (!result.continue) { uiCore.getActionRedirect().reset(); }
                            resolve(result);
                        }
                    }).catch((result) => {
                        this._rejectTreatment(item.key, reject);
                    });

                    break;
                // YLAR -2012.04.25 : Oublie lors de la modification des menus- corrige bug sur compteur incident
                case FORM_CANCELv2:
                    needResolve = false;
                    //appel a une methode que l'on peu surcharger
                    //LLGU - POPIN on gere le submit de manière asynchrone
                    this.currentScreen.beforeCancelOnFormulaire().then((result) => {
                        uiCore.getActionRedirect().reset();
                        //sur le cancel si il n'y a pas de DA visible on vide le shownContextId pour ne pas en afficher après le repost
                        if (uiCore.associatedViewManager.isDown()) {
                            uiCore.associatedViewManager.setShownContextId("");
                        }
                        resolve(result);
                    }).catch((result) => {
                        this._rejectTreatment(item.key, reject);
                    });
                    //doit on continuer le traitement ou pas.
                    window.sCodeLibelleStatus = CANCELING;
                    break;
                case CANCELRETURNv2:
                    window.sCodeLibelleStatus = CANCELING;
                    break;
                case FORM_DELETEv2:
                    needResolve = false;
                    // ABUR - 2006.10.13 - [DYSFCT:15947]
                    // On force le onchange du controle sur lequel etait le focus.
                    provocateOnChange();
                    window.sCodeLibelleStatus = DELETING;
                    // ORIC - 060607 - [DYSF 13201] : Demande de confirmation avant suppression.
                    //LLGU - POPIN on gere le submit de manière asynchrone
                    this.currentScreen.beforeDeleteOnFormulaire().then((result: IIsiUIFlowResult) => {
                        if (result.continue) {
                            // CEGO - 2009.05.19 - [TACHE:24896] : Appel au traitement Ajax du composant metier.
                            //LLGU - POPIN on gere le submit de manière asynchrone
                            this._BusinessCheck("IsiDeleteCheck", "", null, true).then((checkBusinessResult: IsiBc) => {
                                if (checkBusinessResult.bCheckOk) {
                                    this.currentScreen.onDeleteOnFormulaire().then((deleteResult: IIsiUIFlowResult) => {
                                        if (!deleteResult.continue) { uiCore.getActionRedirect().reset(); }
                                        resolve(deleteResult);
                                    }).catch(() => {
                                        this._rejectTreatment(item.key, reject);
                                    });
                                }
                                else {
                                    uiCore.getActionRedirect().reset();
                                    resolve({ result: true, continue: false });
                                }
                            }).catch((result) => {
                                this._rejectTreatment(item.key, reject);
                            });
                        } else {
                            if (!result.continue) { uiCore.getActionRedirect().reset(); }
                            resolve(result);
                        }
                    }).catch((result) => {
                        this._rejectTreatment(item.key, reject);
                    });


                    //LLGU - POPIN on gere le submit de manière asynchrone
                    break;
                case DEL_REQUESTv2:
                case DUPLICATEv2:
                case FORM_EXCELv2:
                case FORM_RSSv2:
                    break;
                case LAUNCHSEARCHv2:
                    // ORIC - 2006.10.16 - [TACHE:8840] : On supprime le focus stocke sur la page, afin d'avoir le focus par defaut en mode recherche.
                    window.iws_SaveFocusedCtrl("");
                    window.sCodeLibelleStatus = SEARCHING;
                    break;
                case NOTE_ITEM:
                    needResolve = false;
                    //GBAU - POPIN
                    GLOB011().open({}, {
                        callback: function () {
                            uiCore.getActionRedirect().reset();
                            resolve({ result: true, continue: false });
                        }
                    });
                    break;
                case FORM_NORMAL_MODEv2:
                    break;
                case UPDATES_LIST:
                    needResolve = false;
                    uiCore.getActionRedirect().reset();
                   uiCore.associatedViewManager.showAssociatedViewByScreenCode("GLOB004LSUIVI", Refresh);
                    resolve({ result: true, continue: false });
                    break;
                case OPEN_SIGNATUREv2:
                    needResolve = false;
                    uiCore.getActionRedirect().reset();
                   uiCore.associatedViewManager.showAssociatedViewByScreenCode("PARC096L",Refresh);
                    resolve({ result: true, continue: false });
                    break;
                case FORM_PROPERTYv2:
                    needResolve = false;
                    //appel a une methode que l'on peu surcharger
                    //LLGU - POPIN on gere le submit de manière asynchrone
                    this.currentScreen.beforePropertyOnFormulaire().then((result) => {
                        if (!result.continue) { uiCore.getActionRedirect().reset(); }
                        resolve(result);
                    })
                        .catch((result) => {
                            this._rejectTreatment(item.key, reject);
                        });
                    ;
                    break;
                case PROPERTYREQUESTv2:
                    break;
                case RESETSEARCHCRITERIAv2:
                    needResolve = false;
                    if (isiApp.screen.pageName === "LIST002") {
                        this.resetComboPagination();

                    } else {
                        resetSearchCriteria();
                    }
                    uiCore.getActionRedirect().reset();
                    resolve({ result: true, continue: false });
                    break;
                case FORM_RESTOREv2:
                    needResolve = false;
                    // CEGO - 2009.05.19 - [TACHE:24896] : Appel a une methode que l'on peut surcharger.
                    //LLGU - POPIN on gere le submit de manière asynchrone
                    this.currentScreen.beforeRestoreOnFormulaire().then((result) => {
                        if (result.continue) {
                            // CEGO - 2009.05.19 - [TACHE:24896] : Appel au traitement Ajax du composant metier.
                            //LLGU - POPIN on gere le submit de manière asynchrone
                            this._BusinessCheck("IsiRestoreCheck", "", null, true).then((checkBusinessResult: IsiBc) => {
                                if (!checkBusinessResult.bCheckOk) { uiCore.getActionRedirect().reset(); }
                                resolve({ result: true, continue: checkBusinessResult.bCheckOk });
                            });
                        } else {
                            if (!result.continue) { uiCore.getActionRedirect().reset(); }
                            resolve(result);
                        }
                    })
                        .catch((result) => {
                            this._rejectTreatment(item.key, reject);
                        });

                    break;
                case FORM_REFRESH:
                    this.currentScreen.beforeRefreshOnFormulaire().then((result) => {
                        if (!result.continue) { uiCore.getActionRedirect().reset(); }

                        //sur le refresh si il n'y a pas de DA visible on vide le shownContextId pour ne pas en afficher après le repost
                        //sauf dans le cas de la LIST002 car le refresh affiche volontairement le resultat de requete
                        if (uiCore.associatedViewManager.isDown() && uiCore.currentScreen.name !== "LIST002") {
                            uiCore.associatedViewManager.setShownContextId("");
                        }
          
                        resolve(result);
                    })
                        .catch((result) => {
                            this._rejectTreatment(item.key, reject);
                        });

                    break;

                case SEARCHv2:
                    // ORIC - 2006.10.16 - [TACHE:8840] : On supprime le focus stocke sur la page, afin d'avoir le focus par defaut en mode recherche.
                    window.iws_SaveFocusedCtrl("");
                    break;

                case FORM_VALIDATEv2:
                    needResolve = false;
                    this._callCheckBeforeValidate(item, actionContext, resolve, reject);
                    break;

                case MenuItemCode.SELECT:
                    needResolve = false;
                    //LLGU - POPIN on gere le submit de manière asynchrone
                    this._currentScreen.beforeValidateOnFormulaire()
                        .then((result) => {
                            if (!result.continue) { uiCore.getActionRedirect().reset(); }
                            resolve(result);
                        })
                        .catch((result) => {
                            this._rejectTreatment(item.key, reject);
                        });
                    break;
                case WORDv2:
                case DATA_WORDv2:
                case MenuItemCode.FORM_CLOSE:
                case MenuItemCode.DATA_CLOSE:
                    needResolve = false;
                    //LLGU - POPIN on gere le submit de manière asynchrone
                    this.currentScreen.beforeCloseOnFormulaire()
                        .then((result) => {
                            if (!result.continue) { uiCore.getActionRedirect().reset(); }
                            resolve(result);
                        })
                        .catch((result) => {
                            this._rejectTreatment(item.key, reject);
                        });
                    break;
                //RGEL - DEV 43751 -  Ajout des action Marquer/Demarquer
                case MARK_ITEM:
                case UNMARK_ITEM:
                    needResolve = false;
                    // onrecupere la liste des elements selectionne
                    let grid: boolean;
                    let gridContext: IsiIWSAssociatedViewContext;
                    let pk: IsiDtoSelectedRecordSet;
                    needResolve = false;
                    if (screenCore.isScreenWithGrid()) {
                        pk = screenCore.associatedViewManager.getListPKSelected(actionContext, false);
                        grid = true;
                        gridContext = actionContext.associatedViewContext;
                    }
                    else {
                        pk = null;
                        grid = false;
                        gridContext = null;
                    }
                    //LLGU - POPIN on gere le submit de manière asynchrone
                    const opts: MarkUnmarkOpt = {
                        itemClick: item.key,
                        recordSet: pk,
                        itemGroup: item.group,
                        inGrid: grid
                    }

                    let mark: IsiPlMark = new IsiPlMark();
                    mark.MarkUnmarkRecord(opts, gridContext)
                        .then((result) => {
                            if (!result.continue) { uiCore.getActionRedirect().reset(); }
                            resolve(result)
                        })
                        .catch((result) => {
                            this._rejectTreatment(item.key, reject);
                        });
                    break;
                case DATA_DESIGN_ITEM:
                case FORM_DESIGN_ITEM:
                    //TABO 05/09/2016 -PB0015662 editer le design
                    //TABO - 18/01/2018 - PB0018090 : Traitement de l'écran de recherche.
                    beforeEditOnFormulaire(actionContext);
                    uiCore.getActionRedirect().reset();
                    // L'affichage du design de l'écran ne doit pas provoquer un repostage, on rejete donc.
                    resolve({ result: true, continue: false });
                    break;
                default:

                    needResolve = false;
                    let keyPrefix: String = actionContext.uiAction.key.substring(0, 6);
                    
                    //on n'exécute pas le _callCheckBeforeValidate que dans le cas ou l'action accepte la validation implicite et qu'une modif a été faite.
                    if (!iws_isInConsultState() && keyPrefix === 'action' && screenCore.menuManager.IsValideImplicite(actionContext.uiAction.key)) {
                        this._callCheckBeforeValidate(item, actionContext, resolve, reject);
                    } else {
                        this._callCheckBeforeOtherAction(item, actionContext, resolve, reject);
                    }

                    break;
            }
            if (needResolve) {
                resolve({ result: true, continue: true });
            }
        });
    }

    private _callCheckBeforeValidate(
        item: IIsiDtoIwsUIAction,
        actionContext: IsiActionContext,
        resolve: (value: IIsiUIFlowResult) => void,
        reject: (reason?: any) => void
    ): void {
        this._checkBeforeValidate(actionContext)
            .then((result) => {
                if (!result.continue) {
                    uiCore.getActionRedirect().reset();
                    //si le checkValidate indique qu'on ne va pas valider, on bypass la vérif pour le submit
                    uiCore.setNeedCheckBusinessRuleRunning(false);
                    resolve(result);
                } else {
                    this._callCheckBeforeOtherAction(item, actionContext, resolve, reject);
                }
            })
            .catch((result) => {
                this._rejectTreatment(item.key, reject);
            });
    }

    private _callCheckBeforeOtherAction(
        item: IIsiDtoIwsUIAction,
        actionContext: IsiActionContext,
        resolve: (value: IIsiUIFlowResult) => void,
        reject: (reason?: any) => void): void {

        const actionNotResetRedirection = [NEWCONFIG_REQUESTv2, ACTION_DEMANDE_ANNULATION]

        this._checkBeforeOtherAction(item, actionContext.event)
            .then((result) => {
                if (!actionNotResetRedirection.includes(actionContext.uiAction.key) && !result.continue) {
                    uiCore.getActionRedirect().reset();
                }
                resolve(result);
            })
            .catch((result) => {
                this._rejectTreatment(item.key, reject);
            });

    }

    _rejectTreatment(itemKey: string, reject) {
        uiCore.getActionRedirect().reset();

        reject();
    }
    /**
     * Cette méthode lance les tests spécifiques pour les
     *
     * */
    _checkBeforeOtherAction(item: IIsiDtoIwsUIAction, event: Event): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            let submit = true;
            // ORIC - 2006.10.17 - [TACHE:8840] : Lorsqu'une vue est demandee explicitement par l'utilisateur
            // (et donc pas en automatique), on notifie le serveur que le focus devra etre fait sur la grille.
            // GELA - 22/06/2011 - [DEV:43894] - On autorise certaines vues associees dans le groupe de menu Outils
            if (item.group == MNUGRP_ASSOCIATEDVIEW ||
                ((item.group == FORM_MNUGRP_MISC || item.group == DATA_MNUGRP_MISC) && (item.key == "PARC096L" || item.key == "GLOB004LSUIVI" || item.key == "GLOB014L"))) {
                if (window.gbAutomaticViewIsLaunch === false) {
                    beforeAssociatedViewOnFormulaire(item);
                    if (uiCore.getSubmit()) {
                        window.iws_SaveFocusedCtrl(DIV_DETAIL);
                    }
                } else {
                    // RAZ de la variable.
                    window.gbAutomaticViewIsLaunch = false;
                }
                uiCore.associatedViewManager.associatedViewFormVerticalMenuClickedWithEvent(uiCore.menuManager.getEntryById(item.id),event);
                submit = false;
            }

            // On verifie que l'item selectionne est une action
            if (item.key.length > 6 && item.key.substr(0, 6) == "action") {

                // enregistrement de l'action sur la grille
                iws_RegisterLastAction(item.key);

                // ABUR - 2006.10.13 - [DYSFCT:15947]
                // On force le onchange du controle sur lequel etait le focus.
                provocateOnChange();

                // CLEM - DYSF75126 doit on tester les champs obligatoires?
                if (uiCore.getSubmit() && this.currentScreen.CheckCompulsoryFieldsForScreen(item)) {
                    uiCore.setSubmit(iwsAllCtrls.CheckCompulsoryFields(false))
                }

                if (uiCore.getSubmit()) {
                    const bShowError = beforeTreatmentBusinessCheckAfterCheckCompulsoryFields(item.key);
                    this._BusinessCheck("IsiTreatmentCheck", item.key, null, bShowError).then((checkBusinessResult: IsiBc) => {
                        if (checkBusinessResult.bCheckOk) {
                            this.currentScreen.beforeActionOnFormulaire(item, checkBusinessResult).then((beforeActionOnFormulaireResult) => {
                                resolve(beforeActionOnFormulaireResult);
                            })
                                .catch((beforeActionOnFormulaireResult) => { reject(checkBusinessResult); });
                        }
                    })
                        .catch((checkBusinessResult) => {
                            reject(checkBusinessResult);
                        });
                }




            } else {
                resolve({ result: true, continue: submit });
            }
        });
    }
    _checkBeforeValidate(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            let item = actionContext.uiAction;
            this._state.translationHardDeletionControls = [];
            // ABUR - 2006.10.13 - [DYSFCT:15947]
            // On force le onchange du controle sur lequel etait le focus.
            if (provocateOnChange()) {

                // TGUE - 19/02/2010- DEV31267 - On verifie les validators sur le formulaire
                //LLGU - POPIN on gere le submit de manière asynchrone
                if (screenCore.iws_checkValidators()) {
                    // Fonction chargee de faire tous les traitements specifiques
                    // Javascript, avant la validation d'un enregistrement. Elle
                    // doit etre surchargee dans la page.
                    this._currentScreen.beforeValidateOnFormulaire().then((result) => {
                        uiCore.log("then beforeValidateOnFormulaire" + Sys.Serialization.JavaScriptSerializer.serialize(result));
                        if (result.continue) {
                            //Dysf75191
                            if (uiCore.CheckFieldsSync([item])) {
                                // ORIC - 2006.10.16 - [TACHE:8840] : On supprime le focus stocke sur la page, afin d'avoir le focus par defaut en mode consultation.
                                // SAUF si on etait deja en consultation.
                                if (!iws_isInUpdateOrConsultState()) {
                                    window.iws_SaveFocusedCtrl("");
                                }

                                // ABUR - 10/04/2005
                                // Fonction chargee de faire tous les traitements specifiques
                                // Javascript, avant la validation d'un enregistrement mais apres
                                // la verification du remplissage des champs obligatoires. Elle
                                // doit etre surchargee dans la page.
                                // Exemple d'utilisation : sur l'ADM020, lors d'une duplication possedant
                                // des lignes, on souhaite demander a l'utilisateur s'il souhaite egalement
                                // les dupliquer, et cette question est a poser que dans le cas ou tous
                                // les champs obligatoires ont ete renseignes.
                                this._currentScreen.beforeValidateOnFormulaireAfterCheckCompulsoryFields(actionContext).then((checkResult: IIsiUIFlowResult) => {
                                    if (checkResult.continue) {
                                        // Si ajout ou duplication
                                        if (iws_isInAddOrDuplicationState()) {
                                            this._BusinessCheck("IsiAddCheck", "", null, true).then((checkBusinessResult: IsiBc) => {
                                                if (checkBusinessResult.bCheckOk) {
                                                    this._currentScreen.beforeValidateOnFormulaireAfterCheckBusiness(checkBusinessResult).then((checkBusinessResult) => {
                                                        resolve(checkBusinessResult);
                                                    }).catch((checkBusinessReject) => { reject(checkBusinessReject); });
                                                }
                                            }).catch((businesscheckReject) => { reject(businesscheckReject); });
                                            // modification
                                        } else if (iws_isInUpdate()) {
                                            this._BusinessCheck("IsiUpdateCheck", "", null, true).then((checkBusinessResult: IsiBc) => {
                                                uiCore.log("then _BusinessCheck" + Sys.Serialization.JavaScriptSerializer.serialize(checkBusinessResult));
                                                if (checkBusinessResult.bCheckOk) {
                                                    this._currentScreen.beforeValidateOnFormulaireAfterCheckBusiness(checkBusinessResult).then((afterCheckBusinessResult: IIsiUIFlowResult) => {
                                                        uiCore.log("then beforeValidateOnFormulaireAfterCheckBusiness" + Sys.Serialization.JavaScriptSerializer.serialize(afterCheckBusinessResult));
                                                        resolve(afterCheckBusinessResult);
                                                    }).catch((afterCheckBusinessReject) => {
                                                        uiCore.log("catch checkBusinessReject" + Sys.Serialization.JavaScriptSerializer.serialize(afterCheckBusinessReject));
                                                        reject(afterCheckBusinessReject);
                                                    });
                                                } else {
                                                    uiCore.log("bCheckOk false");
                                                    resolve({ result: true, continue: false });
                                                }
                                            }).catch((businesscheckReject) => {
                                                uiCore.log("catch businesscheckReject" + Sys.Serialization.JavaScriptSerializer.serialize(businesscheckReject));
                                                reject(businesscheckReject);
                                            });
                                        } else {
                                            resolve({ result: true, continue: true });
                                        }
                                    }
                                    else {
                                        uiCore.log("then _BusinessCheck" + Sys.Serialization.JavaScriptSerializer.serialize(checkResult));
                                        //Si on a détecter un blocage, on remonte directement l'erreur
                                        resolve(checkResult);
                                    }
                                })
                                    .catch((validateCFFieldResult) => {
                                        uiCore.log("catch beforeValidateOnFormulaireAfterCheckCompulsoryFields" + Sys.Serialization.JavaScriptSerializer.serialize(validateCFFieldResult));
                                        reject(validateCFFieldResult);
                                    });
                            } else {
                                const ctrlTab = iwsAllCtrls.CheckTranslatedFields();
                                if (ctrlTab?.length > 0) {
                                    this._handleTranslatedFieldsConfirm(ctrlTab, resolve);
                                } else {
                                    uiCore.log("then provocateOnChange false");
                                    resolve({ result: true, continue: false });
                                }
                            }
                        } else {
                            resolve({ result: true, continue: false });
                        }
                    })
                        .catch((beforeValidateOnFormulaireResult) => {
                            uiCore.log("catch beforeValidateOnFormulaire" + Sys.Serialization.JavaScriptSerializer.serialize(beforeValidateOnFormulaireResult));
                            reject(beforeValidateOnFormulaireResult);
                        });
                }
            } else {
                //LLGU - POPIN on gere le submit de manière asynchrone
                //   id: "actionFormulaire_FORM_VALIDATEv2"
                uiCore.log("else provocateOnChange");
                resolve({ result: true, continue: false });
            }
        });
    }

    /*-- CREATION -----------------------------------------------------------------------------
    '- Auteur      : CEGO
    '- Date        : 19/05/2009
    '- Description : Traitement Ajax pour appeler la methode Check du composant metier.
    '-----------------------------------------------------------------------------------------*/
    _BusinessCheck(codeTreatment, codeAction, infosEntity, showError): Promise<IsiBc> {
        return new Promise<IsiBc>((resolve, reject) => {
            const bRet = true;
            let result: IsiBc = null;

            if (!isScreenWithGrid()) {

                //Si des traitements XML sont en cours, on attend qu'ils se finissent avant de lancer la vérification du composant métier
                if (window.xmlUserSettings.IsRelatedCalculationInProgress()) {
                    window.xmlUserSettings.add_onRelatedCalculFinish(
                        () => this._launchCheckBusiness(codeTreatment, codeAction, infosEntity, showError)
                            .then((result) => resolve(result))
                            .catch((error) => reject(error))
                        , true);
                } else {
                    this._launchCheckBusiness(codeTreatment, codeAction, infosEntity, showError)
                        .then((result) => resolve(result))
                        .catch((error) => reject(error));
                }
            } else {
                result = new IsiBc(null, "", 0, bRet);
                resolve(result);
            }
        });
    }


    /**
     * Lance le traitement Ajax pour la vérification du composant métier
     * @param codeTreatment
     * @param codeAction
     * @param infosEntity
     * @param showError
     * @returns
     */
    _launchCheckBusiness(codeTreatment, codeAction, infosEntity, showError) {
        const bRet = true;
        let clientToServerBusinessObject = false;
        let sInfosEntityJson;
        let result: IsiBc;
        let needResolve = true;
        result = null;
        return new Promise<IsiBc>((resolve, reject) => {
            if (typeof (infosEntity) != "undefined" && infosEntity != null) {
                sInfosEntityJson = infosEntity.values;
            } else {
                sInfosEntityJson = iwsAllCtrls.getSerializeJsonInfosEntity();
            }

            var otherFields = {};
            iws_getOtherFieldsForAjaxSyncBusiness_Overridable(otherFields);
            uiCore.currentScreen.getOtherFieldsForAjaxSyncBuisness(otherFields);
            let verif: IsiPlBusiness = new IsiPlBusiness();
            uiCore.addBusinessRuleRunning(codeTreatment);

            const opts: ParamPlBusiness = {
                codeTreatment: codeTreatment,
                codeAction: codeAction,
                checkToDo: true,
                infosEntity: sInfosEntityJson,
                infosOtherFieldsEntity: otherFields
            }
            verif.CheckBusiness(opts)
                .then((verifResult) => {
                    const objRtnJs = verifResult.businessResult;
                    if (!objRtnJs) {
                        result = new IsiBc(null, "", 0, bRet);
                    } else {
                        // Deserialisation de la chaine JSON
                        clientToServerBusinessObject = ensureClientToServerBusinessObject(clientToServerBusinessObject);

                        //on n'affiche pas le message si le booleen est a faux
                        if (showError === true) {
                            needResolve = false;
                            window.iws_BusinessCheckTreatMessages(objRtnJs, clientToServerBusinessObject).then((checkTreatmentResult) => {
                                uiCore.log("iws_BusinessCheckTreatMessages:" + Sys.Serialization.JavaScriptSerializer.serialize(checkTreatmentResult));
                                if (checkTreatmentResult.continue) {
                                    result = this._createBc(objRtnJs, clientToServerBusinessObject, true);
                                    uiCore.removeBusinessRuleRunning(codeTreatment);
                                    resolve(result);
                                } else {
                                    uiCore.removeBusinessRuleRunning(codeTreatment);
                                    resolve(checkTreatmentResult);
                                }
                            });
                        } else {
                            result = this._createBc(objRtnJs, clientToServerBusinessObject, bRet);
                        }
                    }
                    if (needResolve) {
                        uiCore.removeBusinessRuleRunning(codeTreatment);
                        resolve(result);
                    }
                })
                .catch((o) => {
                    uiCore.removeBusinessRuleRunning(codeTreatment);
                    if (o.response.error) {
                        uiCore.showErrorMessage(o.response.error.errorMessage);
                    }
                    reject(o);
                });
        });
    }

    _createBc(objRtnJs: IIsiServerToClientBusinessObject, clientToServerBusinessObject, bRet: boolean): IsiBc {
        let retour: IsiBc;
        // Construction de l entite
        //GBAU - 08/10/2018 - Modification suite intégration #8732
        let pEntity = new IsiEntity(objRtnJs.fields, objRtnJs.otherFields);

        // Stockage d'une message de retour de la regle metier ainsi que l entite
        retour = new IsiBc(pEntity, objRtnJs.messages, 0, bRet);

        if (clientToServerBusinessObject) {
            flushClientToServerBusinessObject(clientToServerBusinessObject)
        }
        return retour;
    }

    resetComboPagination() {
        this._currentScreen.resetComboPagination();
    }

    uiActionClicked(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            this.currentScreen.beforeActionOnFormulaireForAllForm(actionContext)
                .then((beforeActionResult) => {
                    if (beforeActionResult.continue) {
                        this._actionFormulaire(actionContext).then((actionFormulaireResult) => {
                            resolve(actionFormulaireResult);
                        })
                            .catch((actionFormulaireResult) => {
                                // résout quand même afin d'exécuter la méthode doSubmit.
                                reject(actionFormulaireResult);
                            });
                    }
                })
                .catch((beforeActionResult) => {
                    reject(beforeActionResult);
                });
        });
    }

    /**
     * Gestion de la confirmation des champs traduits vidés
     * @param ctrlTab
     * @param resolve
     */
    private _handleTranslatedFieldsConfirm(ctrlTab: IwsControle[], resolve: (value: IIsiUIFlowResult) => void): void {
        let ctrlLabelsMsg = '';
        let ctrlIdTab: string[] = [];
        ctrlTab.sort((a, b) => a.getLabelElement().textContent.localeCompare(b.getLabelElement().textContent));
        for(const ctrl of ctrlTab) {
            ctrlLabelsMsg += `- ${ctrl.getLabelElement().textContent}\n`;
            ctrlIdTab.push(ctrl.id);
        };

        uiCore.showConfirm({
            message: `${uiCore.getMessage('Err', 'delTradErr').IsiLabel} <div class ="scrollFields">${uiCore.xssEscape(ctrlLabelsMsg)}</div> `,
            iconType: IsiIconType.Question,
            confirmMode: IsiModeConfirm.YesNo,
            callback: async (clickedBtn: IsiButtonType) => {
                if (clickedBtn === IsiButtonType.Yes) {
                    this._state.translationHardDeletionControls = ctrlIdTab;
                }
                resolve({ result: true, continue: true });
            }
        });
    }

}